import React, { useEffect, useState } from "react";
import Button from "../../../../../Elements/Button/Button.js";
import Icon from "../../../../../Elements/Icon/Icon.tsx";
import LeftSide from "./LeftSide.js";
import { useContent } from "../../../../../../contexts/contentContext/contentContext.js";
import {
  convertDate,
  createDaysForPreviousMonth,
  createDaysForNextMonth,
  createDaysForCurrentMonth,
  month,
  days,
  datePickerShortDays,
  currentMonth,
  currentYear,
} from "./Helper.js";
import SelectedDatesHeader from "./SelectedDatesHeader.js";
import "./Datepicker.scss";

const Datepicker = ({
  setStartDate,
  startDate,
  setEndDate,
  endDate,
  setAllTime,
  allTime,
  setDisplayDatepicker,
}) => {
  const { getTextByKey, getDirection } = useContent();
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [allDays, setAllDays] = useState([]);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [customDays, setCustomDays] = useState(false);
  const [activeButton, setActiveButton] = useState("");
  const [changeStartDate, setChangeStartDate] = useState(false);
  const [changeEndDate, setChangeEndDate] = useState(false);

  useEffect(() => {
    createCalendar(currentYear, currentMonth);
  }, []);

  useEffect(() => {
    createCalendar(selectedYear, selectedMonth);
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    if (!selectedStartDate && startDate) {
      const dayOfMonth = startDate.getDate();
      //get date format 01-01-2021
      const date = convertDate(startDate);
      const isCurrentMonth = date.includes(currentMonth);
      const newObj = {
        date: date,
        dayOfMonth: dayOfMonth,
        isCurrentMonth: isCurrentMonth,
      };
      setSelectedStartDate(newObj);
    }
    if (!selectedEndDate && endDate) {
      const dayOfMonth = endDate.getDate();
      //get date format 01-01-2021
      const date = convertDate(endDate);
      const isCurrentMonth = date.includes(currentMonth);
      const newObj = {
        date: date,
        dayOfMonth: dayOfMonth,
        isCurrentMonth: isCurrentMonth,
      };
      setSelectedEndDate(newObj);
    }
  }, [selectedStartDate, selectedEndDate]);

  const createCalendar = (year, month) => {
    let current = createDaysForCurrentMonth(
      year,
      month,
      new Date(year, month, 0).getDate()
    );
    let prev = [];
    if (month > 1) {
      prev = createDaysForPreviousMonth(year, month - 1);
    } else {
      prev = createDaysForPreviousMonth(year - 1, 12);
    }
    let next = [];
    if (month < 12) {
      next = createDaysForNextMonth(year, month + 1);
    } else {
      next = createDaysForNextMonth(year + 1, 1);
    }
    const days = [...prev, ...current, ...next];
    //set the first 42 days
    setAllDays(days.slice(0, 35));
    //setAllDays(days);
  };

  const prevMonth = () => {
    if (selectedMonth > 0) {
      setSelectedMonth(selectedMonth - 1);
    } else {
      setSelectedMonth(11);
      setSelectedYear(selectedYear - 1);
    }
  };
  const nextMonth = () => {
    if (selectedMonth < 11) {
      setSelectedMonth(selectedMonth + 1);
    } else {
      setSelectedMonth(0);
      setSelectedYear(selectedYear + 1);
    }
  };

  //check if day in calendar is in the selected dates range
  const ifActive = (day) => {
    let bool = false;
    if (selectedStartDate && selectedEndDate) {
      if (
        new Date(day.date) <= new Date(selectedEndDate.date) &&
        new Date(day.date) >= new Date(selectedStartDate.date)
      ) {
        bool = "active-days";
      }
      if (day.date === selectedEndDate.date) {
        bool = "edges end";
      }
      if (day.date === selectedStartDate.date) {
        bool = "edges start";
      }
    }
    if (allTime && day.date <= convertDate(new Date())) {
      bool = "active-days";
    }
    return bool;
  };

  //check of the selected date is Start date or End date
  const selectDays = (day) => {
    if (!customDays) {
      setCustomDays(true);
      setActiveButton("custom");
    }
    if (changeEndDate) {
      setSelectedEndDate(day);
      setChangeEndDate(false);
    } else if (changeStartDate) {
      setSelectedStartDate(day);
      setChangeStartDate(false);
    } else {
      if (selectedStartDate) {
        setSelectedEndDate(day);
      } else {
        setSelectedStartDate(day);
      }
    }
  };

  //apply the dates and update the Activity Reports Page's dates inputs
  const applyDates = () => {
    if (allTime) {
      setDisplayDatepicker(false);
      setCustomDays(false);
    } else {
      if (selectedStartDate && selectedEndDate) {
        setStartDate(new Date(selectedStartDate.date));
        setEndDate(new Date(selectedEndDate.date));
        setDisplayDatepicker(false);
        setCustomDays(false);
      }
    }
  };

  const checkIfDayIsSundayOrSaturday = (day) => {
    const dayOfWeek = new Date(day.date).getDay();
    if (dayOfWeek === 0) {
      return "sunday";
    } else if (dayOfWeek === 6) {
      return "saturday";
    }

    return "";
  };

  return (
    <div className="date-picker">
      <LeftSide
        activeButton={activeButton}
        setActiveButton={setActiveButton}
        customDays={customDays}
        setCustomDays={setCustomDays}
        allTime={allTime}
        setAllTime={setAllTime}
        setSelectedStartDate={setSelectedStartDate}
        setSelectedEndDate={setSelectedEndDate}
      />
      <div className="right-side">
        <SelectedDatesHeader
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          allTime={allTime}
          setAllTime={setAllTime}
          customDays={customDays}
          setCustomDays={setCustomDays}
          selectedStartDate={selectedStartDate}
          selectedEndDate={selectedEndDate}
          setDisplayDatepicker={setDisplayDatepicker}
          setSelectedStartDate={setSelectedStartDate}
          setSelectedEndDate={setSelectedEndDate}
          setChangeStartDate={setChangeStartDate}
          setChangeEndDate={setChangeEndDate}
        />
        <div className="calendar-month">
          <section className="calendar-month-header">
            <div
              id="selected-month"
              className="calendar-month-header-selected-month"
            >
              <span
                id="previous-month-selector"
                onClick={() => {
                  prevMonth();
                }}
              >
                <Icon
                  small
                  iconClass="arrow-class"
                  name={
                    getDirection() === "rtl"
                      ? "arrow-right-datepicker"
                      : "arrow-left-datepicker"
                  }
                />
              </span>
              {getTextByKey(month[selectedMonth])} {selectedYear}
              <span
                id="next-month-selector"
                onClick={() => {
                  nextMonth();
                }}
              >
                <Icon
                  iconClass="arrow-class"
                  small
                  name={
                    getDirection() === "rtl"
                      ? "arrow-left-datepicker"
                      : "arrow-right-datepicker"
                  }
                />
              </span>
            </div>
          </section>
          <ol id="days-of-week" className="day-of-week">
            {datePickerShortDays.map((item, i) => (
              <li key={i}>{getTextByKey(item).substring(0, 1)}</li>
            ))}
          </ol>
          <ol id="calendar-days" className="days-grid">
            {allDays.map((day, i) => (
              <li
                key={i}
                onClick={() => {
                  selectDays(day);
                }}
                className={`calendar-day ${
                  !day.isCurrentMonth ? "calendar-day--not-current" : ""
                } ${
                  day.date === convertDate(new Date())
                    ? "calendar-day--today"
                    : ""
                } ${ifActive(day)} ${checkIfDayIsSundayOrSaturday(day)}`}
              >
                <span>{day.dayOfMonth}</span>
              </li>
            ))}
          </ol>
          <div className="btn-apply">
            <Button
              onClick={() => {
                applyDates();
              }}
            >
              {getTextByKey("apply")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Datepicker;
